module.exports = __webpack_public_path__ + "static/media/mobile.20e894b2.svg";